<template>
  <div class="main">
    <!-- loading 一键生成 -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="{ visible: loading, text: loadingtext }"
    ></div>
    <heads></heads>
    <banners></banners>
    <div class="content">
      <div class="cons">
        <!-- 生成论文 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">论文写作</div>
            <el-form-item label="输入标题">
              <el-input v-model="form2.bt" placeholder="请输入标题" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="danger" @click="clickdagang()"
                >立即生成</el-button
              >
            </div>
            <el-form-item label="论文详情">
              <el-input autosize type="textarea" v-model="reslunwen" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";
// loading
let loading = ref(false);
let loadingtext = ref(" ");
let randsum = 0;
// 提纲
let tigang = ref("");
// 引言
let yinyan = ref("");
let cankaowenxian = ref("参考文献：\n");
// 摘要关键词
let zhaiyaoguanjianci = ref("");
// 每个问题的结果
let reswenti1 = ref("");
let reswenti2 = ref("");
let reswenti3 = ref("");
let reswenti4 = ref("");

let reswenti6 = ref("");
// 全文
let reslunwen = ref("");
// let reslunwenmini = ref("");

let resobj = ref("");
let form = reactive({
  bt: "",
  ckwx: [],
  writerorg: `学术论文“论文标题“选择要求有一定的“创新性“、”实用性“和”科学性“等要求。假如你是一名顶级学者，请围绕 “@标题@”的中心内容意思，生成十篇题目供参考，每个论文标题只写一句话。中间不能出现符号，又如“ XXX”，输出格式为：
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX．
请注意用Markdown格式输出, 以下是关键词：`,
  writerorg2: "",
  resobj: "",
});
let form2 = reactive({
  bt: "",
  zz: "顶级学者",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”的中心内容意思，生成一篇教学论文学术交流大纲，注意，学术论文写作，有格式规范，请务必注意。
要求如下：
1、请注意用阿拉伯数字编号。如“0；1，1.1，1.2，1.3，1.4；2，2.1，2.2，2.3，2.4；3，3.1，3.2，3.3，3.4；4，4.1，4.2，4.3，4.4；5 结束语”的示例。
2、要求论文提纲各级标题有新颖性，每个标题只写一句话。围绕“论文标题“分为六部分。如示例只写到二级标题，每一级都要按示例写满，不要多写也不要少写。
3、教学学术论文引言请按标准的教学学术论文要求来进行写作、修改、润色。关于引言部分要特别注意要求如下：第一点，论文写作的背景是什么？第二点，论文研究的需求是什么？第三点，这篇论文的任务是什么？第四点，写这篇论文的目的是什么？第五点，在任务或论文目标中前导性地介绍你要采用或构造什么方法、获得什么样的结果以及期望什么样的结论。第六点，输出段落为一段。总体连成一段输出，且输出字字数要据控制在300字以 上500字以内。
4、论文引言输出格式要求：按“用一句话来描述“研究背景”→用一句话来描述“研究需求”→用一句话来描述“研究任务”→用一句话来描述“论文目标””这样的顺序介绍，一个也不能少，每一层意思只写。
5、引文输出格式：（XXX写成一段，且不要出现“随着”这个词）。
6、正文第二部分，要在提纲中注明哪一小点上要写一个安全来进行分析，按提纲格式输出。
第三部部分要有要举例举出例子说明并分析。
请根据以下关键词并进行组合，并用MARKDOWN格式输出。如 (引言部分)（第一部分）（第二部分）（第三部分）（第四部分）（结束语部分），不要出现失误。输出格式为： 
（引言部分）
0 引言
XX
（第一部分）
1 XXX
1.1	XXX 
1.2	XXXX 
1.3	XXXX （举例说明并有分析结论）
1.4   XXXX
（第二部分）
2 XXX
2.1	XXX 
2.2	XXX （举例说明并分析）
2.3	XXX
2.4   XXX
（第三部分）
3 XXX
3.1	XXX （举例说明并有设计相关数值）
3.2	XXX 
3.3	XXX 
3.4   XXX
（第四部分）
4 XXX 
4.1	XXX 
4.2	XXXX （举例说明）
4.3	XXXX 
4.4   XXXX
（结束语部分）
结束语`,
  writerorg2: "",
});
let form01 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第一部分“或者“1.X“的内容进行写作，不要展开其他部分内容。
要求：
1、在1 和1.1之间先展开只要重要的3句过渡性的语言；但在“1.4”之后不需要写总结性语言，即“1.X”部分不写总结语。
2、每一个小节展开详细描述五百字（500字），但不要分点描述，整合起来写。但请还要注意每一标题前面的阿拉伯数字序号都要原样保留，结果输出中不要出现论文标题。
3、请记住不要展开写，只写“指定”部分的相关内容1500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第一部分“或者“1.X“的内容，而不要输出标题。
4、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
5、输出格式为：
“1 XXX
    XXXXX（3句话）
1.1 XXXX
（写三层意思，800字左右）
1.2 XXXX
（写三层意思，800字左右）
1.3XXXX
（写三层意思，800字左右）
1.4XXXX
（写三层意思，800字左右）
（不写总结）
”
大纲如下：`,
});
let form02 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第二部分“或者“2.X“的内容进行写作，不要展开其他部分内容。
要求：
1、在“2 ”和“2.1”之间先展开只要重要的3句过渡性的语言；但在“2.4”之后不需要写总结性语言，即“2.X”部分不写总结语。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如
“2，2.1，2.2，2.3，2.4”
3、请记住不要展开写，只写“指定”的“第二部分“或者“2.X“部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第二部分“或者“2.X“的内容，而不要输出论文题目。
4、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
5、输出格式为：
“2 XXX
    XXXXX（3句话）
2.1 XXXX
（写三层意思，800字左右）
2.2 XXXX
（写三层意思，800字左右）
2.3XXXX
（写三层意思，800字左右）
2.4XXXX
（写三层意思，800字左右）
（不需要写总结性语言）
”
大纲如下：`,
});
let form03 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第三部分“或者“3.X“的内容进行写作，不要展开其他部分内容。
要求：
1、在“3 ”和“3.1”之间先展开只要重要的3句过渡性的语言；但在“3.4”之后不需要写总结性语言，即“3.X”部分不写总结语。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如
“3，3.1，3.2，3.3，3.4”
3、请记住不要展开写，只写“指定”的“第三部分“或者“3.X“部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第二部分“或者“2.X“的内容，而不要输出论文题目。
4、强调一下：“3.1	XXX （举例说明并有设计相关数值）”， 这里一定要完善数据与数值，并进行分析，必要时可以插入一个表格，但要有表头与内容、注解等要素。
5、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
6、输出格式为：
“3 XXX
    XXXXX（3句话）
3.1 XXXX
（写三层意思，800字左右）
3.2 XXXX
（写三层意思，800字左右）
3.3XXXX
（写三层意思，800字左右）
3.4XXXX
（写三层意思，800字左右）
（不写总结）
”
大纲如下：`,
});
let form04 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第四部分“或者“4.X“的内容进行写作，不要展开其他部分内容。
要求：
1、在“4 ”和“4.1”之间先展开只要重要的3句过渡性的语言；但在“4.4”之后不需要写总结性语言，即“4.X”部分不写总结语。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如
“4，4.1，4.2，4.3，4.4”
3、请记住不要展开写，只写“指定”的“第四部分“或者“4.X“部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第四部分“或者“4.X“的内容，而不要输出论文题目。
4、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
5、输出格式为：
“4 XXX
    XXXXX（3句话）
4.1 XXXX
（写三层意思，800字左右）
4.2 XXXX
（写三层意思，800字左右）
4.3XXXX
（写三层意思，800字左右）
4.4XXXX
（写三层意思，800字左右）
（不写总结）
”
大纲如下：`,
});

let form06 = reactive({
  writerorg2: "",
  writerorg: `接下来，根据最先提交的大纲写这篇教学论文学术的“结束语”部分。注意，学术论文写作，有格式规范，请务必注意。
请根据下面提交的大纲的中“结束语部分“的内容进行写作，不要展开其他部分的内容。不要分点描述，而是要整合起来写。
只写“指定”的“结束语部分“或者“结束语“部分的相关内容800字左右，阿拉伯数字序号都要原样保留。
尽量少用虚词写精炼一点。
输出用大白话来写，内容为：本研究通过 [研究主题]，揭示了[主要发现或结论]。不仅丰富了[相关学科或领域]的理论体系，也为[实践领域]提供了新的视角和解决方案。然而，本研究仍存在一些局限性，如[具体局限性描述]，这些局限性也为未来的研究提供了方向。 [未来研究方向或建议]，以推动[相关领域]的持续发展。
输出格式为
“5 结束语（800字左右）
XXX（3段话）
大纲如下：`,
});

let formzhiayaoguanjianci = reactive({
  writerorg: `教学论文的写作，摘要是有一定规范的，请按标准的教学学术论文要求，将下面的摘要进行修改润色。要求如下：
1、说明提出问题的缘由，表明研究的范围和重要性；
2、简要说明研究过程和结论是如何得到的；
3、	简要列出该研究的结果主要有什么，有什么新的发现
4、	输出摘要是，一定要有固定的几个词，并在文中体现出来。如“为XXX，通过XXX，发现XX，提供XX“这样的句式句子结构。
5、摘要字数控制在200字-250字左右。
输出格式如下：”
摘要：为XXX，通过XXX，发现XX，提供XX。
关键词：XX；XX“
大纲如下：`,
});

// 生成标题
const onSubmit11 = () => {
  return post(baseurls + "/api/Kw/GetSearchZl", {
    bt: form.bt,
    sentence: "",
    subhs: "",
  }).then((res) => {
    form.writerorg2 = res.data;
  });
};
const onSubmit12 = () => {
  let temphs = form.writerorg.replace("@标题@", form.bt);
  return post(baseurls + "/api/Kw/GetZlCuts", {
    bt: form.bt,
    sentence: form.writerorg2,
    subhs: temphs,
  }).then((res) => {
    form.resobj = res.data.resdata;
  });
};
// 选定标题
const onSubmit13 = () => {
  return post(baseurls + "/api/Kw/GetTitleTj", {
    sentence: form.resobj,
  }).then((res) => {
    form2.bt = res.data.bt[0].title;
  });
};

// 生成参考文献 异步
const onSubmit121 = () => {
  cankaowenxian.value = "参考文献：\n";
  post(baseurls + "/api/Kw/GetCkwxTj", {
    sentence: form2.bt,
  }).then((res) => {
    form.ckwx = res.data.list;
    form.ckwx.forEach((e) => {
      cankaowenxian.value += `${e}\n`;
    });
  });
};

// 生成大纲
const onSubmit21 = () => {
  // 替换话术
  let temphs = form2.writerorg.replace(/@标题@/g, form2.bt);
  form2.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetDgChatAPI", {
    sentence: form2.writerorg2,
  }).then((res) => {
    tigang.value = res.data.yw;
    yinyan.value = res.data.yy;
  });
};

// 生成摘要关键词
const clickzhaiyaoguanjianci = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: formzhiayaoguanjianci.writerorg + tigang.value,
  }).then((res) => {
    zhaiyaoguanjianci.value = res.data;
  });
};

// 生成第一部分
const onSubmit001 = () => {
  // 替换话术
  let temphs = form01.writerorg.replace(/@标题@/g, form2.bt);
  form01.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form01.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti1.value = res.data;
  });
};
// 生成第二部分
const onSubmit002 = () => {
  // 替换话术
  let temphs = form02.writerorg.replace(/@标题@/g, form2.bt);
  form02.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form02.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti2.value = res.data;
  });
};
// 生成第三部分
const onSubmit003 = () => {
  // 替换话术
  let temphs = form03.writerorg.replace(/@标题@/g, form2.bt);
  form03.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form03.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti3.value = res.data;
  });
};
// 生成第四部分
const onSubmit004 = () => {
  // 替换话术
  let temphs = form04.writerorg.replace(/@标题@/g, form2.bt);
  form04.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form04.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti4.value = res.data;
  });
};
// 生成结束语部分
const onSubmit006 = () => {
  // 替换话术
  let temphs = form06.writerorg.replace(/@标题@/g, form2.bt);
  form06.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form06.writerorg2 + tigang.value,
  }).then((res) => {
    reswenti6.value = res.data;
    //生成全文  标题  摘要关键字  引言   正文   参考文献
    reslunwen.value = `${form2.bt}\n\n${zhaiyaoguanjianci.value}\n${yinyan.value}\n${reswenti1.value}\n\n${reswenti2.value}\n\n${reswenti3.value}\n\n${reswenti4.value}\n\n${reswenti6.value}\n\n${cankaowenxian.value}`;
  });
};

// 同步生成大纲
const clickdagang = async () => {
  if (form2.bt.trim() == "") {
    ElMessage({
      message: "请填写标题",
      type: "warning",
    });
    return;
  }
  loading.value = true;
  loadingtext.value = "正在生成中，当前进度0%，请耐心等待...";
  // 初始化
  randsum = 0;
  let conouttime = 300 + Math.floor(Math.random() * 5) + 1;
  loadingfun(conouttime);
  // 顺序执行方法
  onSubmit121(); //参考文献
  await onSubmit21();
  await clickzhaiyaoguanjianci();
  await onSubmit001();
  await onSubmit002();
  await onSubmit003();
  await onSubmit004();
  await onSubmit006();

  loading.value = false;
};

const loadingfun = (outtime) => {
  let randNumtemp = Math.floor(Math.random() * 5) + 1;
  if (loading.value) {
    setTimeout(() => {
      randsum += randNumtemp;
      if (randsum < outtime) {
        let temprandnum = ((randsum / outtime) * 100).toFixed(2);
        loadingtext.value = `正在生成中，当前进度${temprandnum}%，请耐心等待...`;
        loadingfun(outtime);
      } else {
        loadingtext.value = `正在生成中，当前进度99.99%，请耐心等待...`;
      }
    }, randNumtemp * 1000);
  }
};
</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
